export default "__VITE_ASSET__DERltcYz__"